export default "__VITE_ASSET__853a402c__"